export default "__VITE_ASSET__kD8Koe08__"